import React from 'react'
import { Switch, withRouter, Route, Redirect } from 'react-router-dom'
import PropTypes from 'prop-types'
import PrivateRoute from 'hocs/PrivateRoute'
import DashboardLayout from '../components/Layouts/DashboardLayout'
import DashboardOverview from '.'
import CarsRoutes from './Cars'
import CarRequestRoutes from './CarRequests'
import CarOrdersRoutes from './CarOrders'
import CustomerRoutes from './Customers'
import UserRoutes from './users'
import CarCreationTasksRoutes from './CarCreationTasks'
import CustomDutiesRoutes from './CustomDuties'
import ShippingFeesRoutes from './CustomDuties/ShippingFees'
import { BankingRatesRoutes, CarRatesRoutes } from './CustomDuties/Rates'
import TransactionsRoutes from './Transactions'
import PaymentRoutes from './Transactions/PaymentRoutes'
import KnowledgeBaseRoutes from './DutyAssistant/KnowledgeBase'
import DutyPricingRoutes from './DutyAssistant/Pricing'
import DutyDealersRoutes from './DutyAssistant/Dealers'
import DutyPaymentsRoutes from './DutyAssistant/Payments'
import DutyAssistantSettingsRoutes from './DutyAssistant/AssistantSettings'
import DutyConversationsRoutes from './DutyAssistant/Conversations'
import DutyCustomersRoutes from './DutyAssistant/Customers'
import DutyBroadcastsRoutes from './DutyAssistant/Broadcasts'
import DutyPromotionsRoutes from './DutyAssistant/Promotions'
import DutyFollowUpsRoutes from './DutyAssistant/FollowUps'
import DriveTrainBadgesRoutes from './DutyAssistant/DriveTrainBadges'
import MsrpWhitelistRoutes from './DutyAssistant/MsrpWhitelist'
import InsurancePoliciesRoutes from './Insurance/Policies'
import InsuranceSettlementRoutes from './Insurance/Settlement'
import InsuranceSetupRoutes from './Insurance/Setup'
import TrackingRoutes from './Tracking'
import VehicleHistoryRoutes from './VehicleHistory'
import InventoryAssistantRoutes from './InventoryAssistant'
import GrowthRoutes from './Growth'
// import SegmentRoutes from './Segments'
// import ShippingBatceshRoutes from './ShippingBatches'
import PageNotFound from 'PageNotFound'

/*
  Pages that serve every service, moved out of the service that happened to build them first
  (Assistant settings and the rest sat under Custom Duties, Payment routes under Transactions).
  The old addresses redirect, keeping whatever followed them, so bookmarks and open tabs survive.
*/
const MOVED_TO_SETTINGS = [
  ['duty-assistant/assistant-settings', 'settings/assistant'],
  ['duty-assistant/knowledge-base', 'settings/knowledge-base'],
  ['duty-assistant/follow-ups', 'settings/follow-ups'],
  ['duty-assistant/broadcasts', 'settings/broadcasts'],
  ['transactions/payment-routes', 'settings/payment-routes']
]

const DashboardRoutes = props => {
  return (
    <DashboardLayout>
      <Switch>
        {MOVED_TO_SETTINGS.map(([from, to]) => (
          <Route
            key={from}
            path={`${props.match.path}${from}`}
            render={({ location }) => (
              <Redirect
                to={{ ...location, pathname: location.pathname.replace(`/${from}`, `/${to}`) }}
              />
            )}
          />
        ))}
        <PrivateRoute
          exact
          path={props.match.path}
          component={DashboardOverview}
        />
        {/* Settings: the pages every service shares. */}
        <PrivateRoute
          path={`${props.match.path}settings/assistant`}
          component={DutyAssistantSettingsRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}settings/knowledge-base`}
          component={KnowledgeBaseRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}settings/follow-ups`}
          component={DutyFollowUpsRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}settings/broadcasts`}
          component={DutyBroadcastsRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}settings/payment-routes`}
          component={PaymentRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}users`}
          component={UserRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}inventory-assistant`}
          component={InventoryAssistantRoutes}
        />
        <PrivateRoute path={`${props.match.path}cars`} component={CarsRoutes} />
        <PrivateRoute
          path={`${props.match.path}car-orders`}
          component={CarOrdersRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}customers`}
          component={CustomerRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}car-tasks`}
          component={CarCreationTasksRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties/shipping-fees`}
          component={ShippingFeesRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties/customers`}
          component={DutyCustomersRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties/msrp-whitelist`}
          component={MsrpWhitelistRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties/banking-rates`}
          component={BankingRatesRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties/car-rates`}
          component={CarRatesRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}custom-duties`}
          component={CustomDutiesRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/pricing`}
          component={DutyPricingRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/dealers`}
          component={DutyDealersRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/payments`}
          component={DutyPaymentsRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/conversations`}
          component={DutyConversationsRoutes}
        />
        {/* Car requests from the app: what customers asked us to find. */}
        <PrivateRoute
          path={`${props.match.path}car-requests`}
          component={CarRequestRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/promotions`}
          component={DutyPromotionsRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}duty-assistant/drive-train-badges`}
          component={DriveTrainBadgesRoutes}
        />
        {/* Insurance: the worklist, the money owed in both directions, and the rates. */}
        <PrivateRoute
          path={`${props.match.path}insurance/policies`}
          component={InsurancePoliciesRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}insurance/settlement`}
          component={InsuranceSettlementRoutes}
        />
        <PrivateRoute
          path={`${props.match.path}insurance/setup`}
          component={InsuranceSetupRoutes}
        />
        {/* Shipment tracking: the worklist, one shipment, and the three setup pages. */}
        <PrivateRoute
          path={`${props.match.path}tracking`}
          component={TrackingRoutes}
        />
        {/* Vehicle history reports: the orders our team works, the packages the owner prices,
            and the supplier account behind both. */}
        <PrivateRoute
          path={`${props.match.path}vehicle-history`}
          component={VehicleHistoryRoutes}
        />
        <PrivateRoute path={`${props.match.path}growth`} component={GrowthRoutes} />
        <PrivateRoute
          path={`${props.match.path}transactions`}
          component={TransactionsRoutes}
        />
        {/* <PrivateRoute
          path={`${props.match.path}segments`}
          component={SegmentRoutes}
        /> */}
        {/* <PrivateRoute
          path={`${props.match.path}batches`}
          component={ShippingBatceshRoutes}
        /> */}
        <Route component={PageNotFound} />
      </Switch>
    </DashboardLayout>
  )
}

DashboardRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(DashboardRoutes)
